import React from "react";
import SmartImage from "../SmartImage";
import images from "../../Constant/images";
import CustomText from "../Text";
import { FONTS, STYLES } from "../../Constant/Theme";
import Colors from "../../Constant/Colors";
import {
  Container,
  HeaderDiv,
  MobileHeader,
  OptionsDiv,
  SearchDiv,
  TopBarDiv,
  TopBarNav,
  TopBarNavDiv,
} from "./style";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../SearchBar";
import { useNavigate } from "react-router-dom";
import { LogoutRequest, clearToken } from "../../Redux/actions/auth";
import { clearHome } from "../../Redux/actions/home";
import { auth } from "../../Utils/auth";
import Dropdown from "../DropDownPop";
import { VerticalAlign } from "../CustomStyles";

const TopBar = ({ handleSideBar, handleMenu }) => {
  const { selectedSideMenu, topBarList, token } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const screenWidth = window.innerWidth;
  const navigate = useNavigate();

  const handleLogout = () => {
    let refresh = auth.getRefreshToken();
    let data = { refresh };
    dispatch(LogoutRequest(data));
    dispatch(clearToken(token));
    dispatch(clearHome());
    auth.logout();
    setTimeout(() => navigate("/"), 10);
  };

  const navigateToSetting = () => {
    navigate("/editProfile",{});
  };

  const mobMenu = [
    ...topBarList,
    { title: "Edit Profile" },
    { title: "Logout" },
  ];
  const handleMobTopBar = (e) => {
    if (e.title.toLowerCase() === "logout") {
      handleLogout();
    } else if (e.title === "Edit Profile") {
      navigateToSetting();
    } else {
      handleMenu(e);
    }
  };

  return (
    <>
      <Container screenWidth={screenWidth}>
      <HeaderDiv style={{
        marginRight:40
      }}>
        <VerticalAlign>

        <SmartImage
          src={images?.logo}
          alt="Logo"
          style={{
            width: 55,
            height: 55,
            marginBottom:10
          }}
          />
        <CustomText
          style={{ ...FONTS.SemiBold24, color: Colors.primary }}
          text={"Power Education"}
          />
          </VerticalAlign>
      </HeaderDiv>

          <div >
          <Container screenWidth={screenWidth}>

            <TopBarDiv>
              <div>
                <CustomText
                  text={selectedSideMenu?.title}
                  style={{ ...FONTS.SemiBold20 }}
                />
              </div>

              <OptionsDiv>
                <span onClick={navigateToSetting}>
                  <SmartImage
                    src={images.editProfile}
                    style={{
                      height: 30,
                      width: 30,
                      cursor: "pointer",
                      marginRight: 20,
                    }}
                  />
                </span>
                <span onClick={handleLogout}>
                  <SmartImage
                    src={images.logout}
                    style={{ height: 25, width: 25, cursor: "pointer" }}
                  />
                </span>
              </OptionsDiv>
            </TopBarDiv>
          </Container>
          <TopBarNavDiv>
            {topBarList?.map((each) => (
              <TopBarNav
                key={each?.id}
                onClick={() => handleMenu(each)}
                isSelected={each?.isSelected}
              >
                <p>{each?.title}</p>
              </TopBarNav>
            ))}
          </TopBarNavDiv>
        </div>
      </Container>
      <MobileHeader screenWidth={screenWidth}>
        <span onClick={handleSideBar}>
          <SmartImage
            src={images.hamburger}
            alt="hamburger"
            style={{ width: 30, height: 30, cursor: "pointer" }}
          />
        </span>

        <CustomText
          text={selectedSideMenu?.title}
          style={{ ...FONTS.SemiBold24, color: Colors.whiteThemeColor }}
        />

        <Dropdown
          items={mobMenu}
          icon={images.dotsWhite}
          onItemClick={(e) => handleMobTopBar(e)}
          iconStyle={{
            transform: "rotate(90deg)",
          }}
          position={'bottom'}
          alignment={'left'}
        />
      </MobileHeader>
    </>
  );
};

export default TopBar;
